module.exports = __webpack_public_path__ + "img/icon-button-reject.4dc81f1a.svg";